import { shouldEnableDatadogRum } from "@core/services/datadog-rum";
import { datadogRum } from "@datadog/browser-rum";
import { useSession } from "next-auth/react";
import { useEffect, useRef } from "react";

const IdentifyDatadogRumUser = () => {
  const { data } = useSession();
  const user = data?.user;
  const email = user?.email;
  const userId = user?.id;

  const identifiedRef = useRef(false);

  useEffect(() => {
    if (
      !email ||
      !userId ||
      // Prevent multiple runs
      identifiedRef.current ||
      !shouldEnableDatadogRum()
    ) {
      return;
    }

    try {
      console.log("Identifying DD user...");
      identifiedRef.current = true;
      datadogRum.setUser({ id: String(userId), email, name: email });
      datadogRum.startSessionReplayRecording();
    } catch (error) {
      console.error("Error identifying DD user:", error);
    }
  }, [email, userId]);

  return null;
};

export default IdentifyDatadogRumUser;
